import type { Fields } from "@vuex-orm/core";

// eslint-disable-next-line import/no-cycle
// import { Slide } from "./ActionHierarchy";
import { Slide } from "./ActionHierarchy";
// eslint-disable-next-line import/no-cycle
import Video from "./Video";
// eslint-disable-next-line import/no-cycle
import Upload from "./Upload";
import type { ActionWithDuration, BlobActingAsFile } from "./ActionTypes";

export class FileSlide extends Slide implements ActionWithDuration {
  public static entity = "fileSlides";

  public static baseEntity = "actions";

  public static fields(): Fields {
    return {
      ...super.fields(),
      duration: this.number(-1),
      // When uploading, the `signedFileId ` is sent to the server to attach the active storage object to the `Action`
      // (or rather: the server - side`FileSlide`) and never used again.It uses the default Rails mechanism of assigning
      // it directly to the attachment attribute(`file` in the case of`FileSlide`); assigning it like that creates an
      // `ActiveStorage::Attachment` join model that ties the `FileSlide` object to the file record
      // (`ActiveStorage::Blob`) itself.
      // Normally with Rails you’d then use the URLs the ActiveStorage returns, but we handle this differently; we have
      // our own controller action that access the underlying `key` of the ActiveStorage Blob.That’s basically the
      // mechanism we used before.
      signedFileId: this.string("").nullable(),
      // Therefore we need the server to return the `key` (`fileKey` in the client) and for that to be separate from the
      // signed ID, because they’re indeed different things.
      fileKey: this.string("").nullable(),
      upload: this.morphOne(Upload, "uploadableId", "uploadableType"),
    };
  }

  public declare duration: number;

  public declare signedFileId: string | null;

  public declare fileKey: string | null;

  public declare upload: Upload | null;

  public get fileUrl(): string | null {
    if (!this.fileKey || !this.videoId) return null;
    return Video.find(this.videoId)?.fileUrl(this.fileKey) || null;
  }

  public get proxiedFileUrl(): string | null {
    if (!this.fileKey || !this.videoId) return null;
    return Video.find(this.videoId)?.proxiedFileUrl(this.fileKey) || null;
  }

  public async uploadFile(
    file: File | BlobActingAsFile,
  ): Promise<{ signedFileId: string; fileKey: string }> {
    this.upload = await Upload.for(this);
    const activeStorageBlob = await this.upload.perform(file);
    setTimeout(() => {
      this.upload?.$delete();
      // for reactivity
      this.upload = null;
    }, 1500);

    return {
      signedFileId: activeStorageBlob.signed_id,
      fileKey: activeStorageBlob.key, // for local preview only; received from backend on refresh.
    };
  }
}
